import { render, staticRenderFns } from "./driftPoint.vue?vue&type=template&id=1db37a37"
import script from "./driftPoint.vue?vue&type=script&lang=js"
export * from "./driftPoint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports